import React from "react"
import { Flex } from "@chakra-ui/react"
import Header from "../sections/Header"
import Footer from "../sections/Footer" // will add this in the part 2

export default function Layout({ children, menuOpen, setMenuOpen }) {
  return (
    <Flex
      direction="column"
      align="center"
      m="0 auto"
      minH="100vh"
      width="100%"
    >
      <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
      {children}
      <Footer />
    </Flex>
  )
}